import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shared-scenarios-viewed"
export default class extends Controller {
  connect() {
    window.dispatchEvent(new CustomEvent("shared-scenarios:viewed"))
  }
}
